
import React, { useState } from 'react';

import useFilterForCheckbox from '../hooks/useFilterForCheckbox';

import FilterItem from './FilterItem';

/**
 * FilterLanguages
 *
 * A filter that returns selected languages
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {Object} props.scrollToTop
 */
const LanguageFilter = ({ context, setStart, dataCode, scrollToTop }) => {
  const [ isActive, setIsActive ] = useState( false );
  const contextLanguages = JSON.parse( context?.selectedLanguages );

  const {
    checked,
    setChecked,
    handleFilter
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop );

  const languages = [
    {
      label: 'English',
      value: 'E'
    },
    {
      label: 'Spanish',
      value: 'SP'
    }
  ];

  const selectedLanguages = languages.filter( ( language ) => contextLanguages.includes( language.value ) );

  return (
    selectedLanguages.length > 0 && (
      <FilterItem
        data={ selectedLanguages }
        setStart={ setStart }
        dataCode="data-language-codes"
        title="Language"
        isActive={ isActive }
        setIsActive={ setIsActive }
        checked={ checked }
        setChecked={ setChecked }
        handleFilter={ ( e, index ) => handleFilter( e, index ) }
        scrollToTop={ scrollToTop }
      />
    )

  );
};

export default LanguageFilter;
